import React from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
const EditorButtons = props => {
  const { classes } = props
  return <div className={classes.editorButtonsRoot}></div>
}

export default withStyles(styles)(EditorButtons)
